<template>
  <div class="saturation" @mousedown.prevent.stop="selectSaturation">
    <canvas ref="canvasSaturation" class="canvas" />
    <div :style="slideSaturationStyle" class="slide" />
  </div>
</template>

<script>
import mixin from './mixin';

export default {
  mixins: [mixin],
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    hsv: {
      type: Object,
      default: null,
    },
    size: {
      type: Number,
      default: 208,
    },
    width: {
      type: Number,
      default: 208,
    },
    height: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      slideSaturationStyle: {},
    };
  },
  watch: {
    hsv() {
      this.slideSaturationStyle = { ...this.slideSaturationStyle, background: this.color };
    },
  },
  mounted() {
    this.renderColor();
    this.renderSlide();
  },
  methods: {
    renderColor() {
      const canvas = this.$refs.canvasSaturation;
      const size = this.size;
      const ctx = canvas.getContext('2d');
      canvas.width = this.width;
      canvas.height = this.height;

      ctx.fillStyle = this.color;
      ctx.fillRect(0, 0, this.width, this.height);

      this.createLinearGradient('l', ctx, this.width, this.height, '#FFFFFF', 'rgba(255,255,255,0)');
      this.createLinearGradient('p', ctx, this.width, this.height, 'rgba(0,0,0,0)', '#000000');
    },
    renderSlide() {
      this.slideSaturationStyle = {
        left: this.hsv.s * this.width - 5 + 'px',
        top: (1 - this.hsv.v) * this.height - 5 + 'px',
        background: this.color,
      };
    },
    selectSaturation(e) {
      const { top: saturationTop, left: saturationLeft } = this.$el.getBoundingClientRect();
      const ctx = e.target.getContext('2d');

      const mousemove = (e) => {
        let x = e.clientX - saturationLeft;
        let y = e.clientY - saturationTop;

        if (x < 0) {
          x = 0;
        }
        if (y < 0) {
          y = 0;
        }
        if (x > this.width) {
          x = this.width;
        }
        if (y > this.height) {
          y = this.height;
        }

        let rX = x - 15;
        const rY = y - 5;

        if (rX < 0) {
          rX = 0;
        }

        this.slideSaturationStyle = {
          left: rX + 'px',
          top: rY + 'px',
          background: this.color,
        };

        const imgData = ctx.getImageData(Math.min(x, this.width - 1), Math.min(y, this.height - 1), 1, 1);
        const [r, g, b] = imgData.data;
        this.$emit('selectSaturation', { r, g, b });
      };

      mousemove(e);

      const mouseup = () => {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
    },
  },
};
</script>

<style scoped lang="scss">
.saturation {
  position: relative;
  cursor: pointer;

  .slide {
    position: absolute;
    left: 100px;
    top: 0;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid #fff;
    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
    pointer-events: none;
  }

  .canvas {
    width: 100%;
    height: 100%;
    border-radius: 3px;
    display: inline;
    vertical-align: unset;
  }
}
</style>
